import { send } from "api";
import { ApiErrorResponse } from "../../Api/Model/ApiErrorResponse";


export interface DeleteAccountRequestRequest {
}
export const deleteAccountRequest = (deleteAccountRequestRequest: DeleteAccountRequestRequest): Promise<any> => {
    return send("DeleteAccountRequest", deleteAccountRequestRequest)
}
